import { render, staticRenderFns } from "./Star.vue?vue&type=template&id=39baab0f"
import script from "./Star.vue?vue&type=script&lang=js"
export * from "./Star.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39baab0f')) {
      api.createRecord('39baab0f', component.options)
    } else {
      api.reload('39baab0f', component.options)
    }
    module.hot.accept("./Star.vue?vue&type=template&id=39baab0f", function () {
      api.rerender('39baab0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/storefinder/Resources/Private/Assets/Scripts/Components/Icons/Star.vue"
export default component.exports